  import styled from "styled-components";

  export const FilterInputText = styled.div`
    p {
      color: ${({theme}) => theme.primaryColor};
      font-size: 0.65rem;
      margin-bottom: ${({inline}) => !inline ? "10px" : ""};
      font-family: 'Nunito SemiBold';
    }
  `